import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { PlatformDialogTestComponent } from '../../platform/platform-dialog-test/platform-dialog-test.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-showed-modal',
  templateUrl: './showed-modal.component.html',
  styleUrls: ['./showed-modal.component.scss'],
})
export class ShowedModalComponent implements OnInit {
  loading = false;
  platform: any;
  content: SafeHtml = '';
  constructor(
    private api: ProductApiService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<ShowedModalComponent>
  ) {}

  ngOnInit(): void {
    this.getPlatformInfo(this.data.platform_id);

    this.content = this.sanitizer.bypassSecurityTrustHtml(this.data.content);
  }

  async getPlatformInfo(id: number) {
    try {
      this.loading = true;
      const r = await this.api.getPlatform(id);
      this.platform = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  openPlatform() {
    this.dialogRef.close();
    this.dialog.open(PlatformDialogTestComponent, {
      data: Object.assign({}, this.platform),
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }
}
